export default "__VITE_ASSET__CK1qFAhj__"